module.exports = __webpack_public_path__ + "static/media/expOrange.f115e6e5.svg";